export enum DonationsActionTypes {
  FETCHING = 'donations/FETCHING',
}
